import { render } from "./CommercialsCollections.vue?vue&type=template&id=171d60ae"
import script from "./CommercialsCollections.vue?vue&type=script&lang=js"
export * from "./CommercialsCollections.vue?vue&type=script&lang=js"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__